import { render, staticRenderFns } from "./SiteDetailsInfoCard.vue?vue&type=template&id=b588139c&scoped=true"
import script from "./SiteDetailsInfoCard.vue?vue&type=script&lang=js"
export * from "./SiteDetailsInfoCard.vue?vue&type=script&lang=js"
import style0 from "./SiteDetailsInfoCard.vue?vue&type=style&index=0&id=b588139c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b588139c",
  null
  
)

export default component.exports